import {Asset, Tag, UserAvatar, UserFullname} from "@components";
import {TaskEvent} from "@core/model";
import {KeyboardArrowDown, KeyboardArrowUp, Loop} from "@mui/icons-material";
import {Box, Collapse, Stack, Typography, TypographyProps} from "@mui/material";
import {translate, truncateSx} from "@util";

const Event = ({event, open = false}: {event: TaskEvent; open?: boolean}) => {
  const typoProps: TypographyProps = {
    color: "textPrimary",
    textAlign: "left",
  };

  return (
    <Box
      className="agenda-row-event"
      sx={{
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
        display: "flex",
        gap: open ? 1 : 0,
        py: 0.5,
        minWidth: 0,
        inlineSize: "100%",
      }}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        gap={1}
        flex={1}
        width={"100%"}>
        <Typography
          {...typoProps}
          sx={truncateSx}
          variant="h6"
          fontWeight={open ? "bold" : "normal"}>
          {event.title}
        </Typography>
        {event.recurring && <Loop fontSize="inherit" color="action" />}
        <Box sx={{ml: "auto"}}>
          {open ? (
            <KeyboardArrowUp fontSize="medium" color="action" />
          ) : (
            <KeyboardArrowDown fontSize="medium" color="action" />
          )}
        </Box>
      </Stack>
      <Collapse in={open} sx={{minWidth: 0, inlineSize: "100%"}}>
        <Typography {...typoProps} variant="body2">
          {event.description}
        </Typography>
        <Stack gap={1} direction={"column"} mt={1} alignItems={"start"}>
          <Stack direction={"row"} gap={1}>
            {event.tags?.map(tag => (
              <Tag key={`agenda-event-tag-${tag}`} tag={tag} container="chip" />
            ))}
          </Stack>
          <Stack direction={"row"} gap={2} flex={1}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <UserAvatar id={event.assigneeId} width={24} />
              <Stack alignItems={"start"}>
                <UserFullname userId={event.assigneeId} variant="caption" />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  lineHeight={1}>
                  {translate("entity.task.assignee")}
                </Typography>
              </Stack>
            </Stack>
            <Asset
              id={event.assetId}
              size="small"
              variant="body2"
              subtitleVariant="caption"
              sx={{inlineSize: undefined}}
            />
          </Stack>
        </Stack>
      </Collapse>
    </Box>
  );
};

export {Event};
